import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions, accountActions, chartsActions, strategyModalActions } from '../../../redux/root-action';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Button, CollapsibleHedge } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import AccountCard from './AccountCard';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import {
  modals,
  accountModalViews,
  accountTypeCodes,
  postActions,
  derivedAttributes,
  analyticsTracking
} from '../../../utils/constants';
import { formatAmount, formatAmountWithoutDecimals, keyDown } from '../../../utils/helpers';
import ToggleSection from './ToggleSection';

const StrategyBalanceHeaderText = styled.div`
  padding: 24px 0px 32px;
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  @media (max-width: 767px) {
    padding: 24px 0px 40px;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: normal;
  }
`;

const CurrentBalanceContainer = styled.div`
  // margin: 0 48px 16px;
  padding-bottom: 8px;
  @media (max-width: 768px) {
    // margin: 0 16px 16px;
  }
`;

const CurrentBalance = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 24px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const CurrentBalanceAmount = styled.div`
  float: right;
  font-family: Nimbus Sans Bold;
  font-size: 24px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const AccountsContent = styled.div`
  margin: 0 0px 16px;
  @media (max-width: 767px) {
    margin: 0 0 16px;
  }
`;

const TRPAccountsHeader = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 32px;
  color: ${tokens.ColorGrey600};
  margin: 16px 0 8px;
`;

const OtherAccountsHeader = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 32px;
  color: ${tokens.ColorGrey600};
  margin: 16px 0 8px;
`;

const AccountCardRow = styled.div`
  display: flex;
  flex-wrap: wrap;

  > a {
    flex: 1;
  }
  > div {
    display: flex;
    justify-content: right;
    border-top: 1px solid ${tokens.ColorWhite200};
    flex: 0 0 72px;


  }
  :first-of-type  {
    > a > div, > div {
      border-top: 1px solid ${tokens.ColorBrandBrightBlue};
    }
  }
`;

const AlwaysIncludeText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  color: ${tokens.ColorGrey600};
  margin-left: auto;
  padding-top: 12px;
  text-align: right;
  border-left: 1px solid ${tokens.ColorWhite200};
`;

const StrategyBalanceLinkContainer = styled.div`
  padding: 16px 0 32px;
  text-align: right;
  @media (max-width: 767px) {
    padding: 8px 16px;
    text-align: center;
  }
  button {
    padding: 0;
    font-family: Nimbus Sans Bold;
    font-size: 16px;
    line-height: 22px;
    color: ${tokens.ColorBrandInteractiveBlue};
    text-decoration: none;
    cursor: pointer;

    :hover,
    :active {
      background: none;
      color: ${tokens.ColorBrandInteractiveBlue};
    }
  }
`;

const collapsibleText =
  "Mutual fund share prices and portfolio unit prices are calculated as of the close of trading of each business day and are generally uploaded to our website each business day between 6:00-7:00 PM ET, at which time current account balances should reflect that updated price information. Transactions placed during the current business day for your account will be processed overnight and should be available for viewing in the next morning's account information. Intra-day Brokerage trading activity and pending account activity will not be reflected in your current balance. Balances and prices for linked external accounts and other third-party data are subject to the timing of the respective providers. Balances for manually entered external accounts reflect the most recent manual entry or update.";

interface MyState {
  checkToggle: boolean
}
class StrategyModal extends Component<any, MyState> {
  props: any;
  state: any;

  constructor(props: any) {
    super(props);

    this.state = {
      checkToggle: false,
      originalRiScenario: JSON.parse(JSON.stringify(props.modelledScenario))
    };
  };

  cleanUpObjects = (objArr: Array<Record<any, any>>) => {
    return objArr.map((obj: Record<any, any>) => {
      let cleanedObject = {};
      Object.keys(obj).forEach(key => {
        if (!derivedAttributes.includes(key)) {
          cleanedObject = { ...cleanedObject, [key]: obj[key] };
        }
      });
      return cleanedObject;
    });
  };

  handleSave = () => {
    const {
      hideModal,
      modelIncludeInScenario,
      riScenario
    } = this.props;
    const accounts = riScenario.accounts;
    let includedAccounts = accounts.reduce(
      (accum: number, account: any) => accum + (account.includeInScenario ? 1 : 0),
      0,
    );
    let totalAccounts = riScenario.accounts.reduce(
      (accum: number, account: any) => accum + 1,
      0,
    );
    //strategy-balance-title-input-tile-sub-title
    document.querySelector('#strategy-balance-title-input-tile-sub-title')!.innerHTML = includedAccounts + ' of ' + totalAccounts + ' accounts included';
    document.querySelector('#strategy-balance-title-input-tile-value')!.innerHTML = document.querySelector('#strategy-balance-amount')!.innerHTML;
    modelIncludeInScenario();
    document.getElementsByTagName('html')[0].classList.remove('fixed');
    document.getElementsByTagName('html')[0].removeAttribute('style');
    hideModal();
  };

  handleCancel = () => {
    const { hideModal, riScenario } = this.props;
    let includedAccounts = 0;
    let strategyBalance = 0;
    const totalAccounts = riScenario.accounts.reduce(
      (accum: number, account: any) => accum + 1,
      0,
    );
    riScenario.accounts.forEach((account: any, index: string | number) => {
      account.includeInScenario = this.state.originalRiScenario.accounts[index].includeInScenario;
      account.action = this.state.originalRiScenario.accounts[index].action;
      if (account.includeInScenario) {
        strategyBalance += this.state.originalRiScenario.accounts[index].balance
        includedAccounts += 1;
      }
    })
    document.querySelector('#strategy-balance-title-input-tile-sub-title')!.innerHTML = includedAccounts + ' of ' + totalAccounts + ' accounts included';
    document.querySelector('#strategy-balance-title-input-tile-value')!.innerHTML = formatAmountWithoutDecimals(strategyBalance);
    document.getElementsByTagName('html')[0].classList.remove('fixed');
    document.getElementsByTagName('html')[0].removeAttribute('style');
    hideModal();

  };

  showYourAccountsModal = () => {
    const { showModal, setCurrentView, modelIncludeInScenario } = this.props;
    modelIncludeInScenario();
    showModal(modals.ACCOUNT);
    setCurrentView(accountModalViews.YOUR_ACCOUNTS);
  };

  updateIncludeExcludeToggle = (id: number, name: string) => {
    const {
      riScenario,
      updateIncludeInScenario,
    } = this.props;

    let accounts = riScenario.accounts;
    const tempAccounts = [...accounts];

    for (const account of tempAccounts) {
      if (account.name === name && account.id === id) {
        account.includeInScenario = !account.includeInScenario;
        account.action = 'UPDATE'
        this.setState(prevState => ({
          checkToggle: !prevState.checkToggle
        }));

        return updateIncludeInScenario({ accounts: tempAccounts })
      }
    }
  }

  getDisplayType = ({ displayType, overrideAccountTypeCode }: any) => {
    const { accountTypes } = this.props;
    const filteredAccountType = accountTypes.data.find(
      (accountType: any) => accountType.value === overrideAccountTypeCode,
    );
    return filteredAccountType ? filteredAccountType.name : displayType;
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    const { riScenario, modelledScenario, tempScenario } = this.props;

    // get from props in #148 if needed
    // const accounts = overridenAccountsData && overridenAccountsData.length > 0 ? overridenAccountsData : accountsData;
    const accounts = riScenario.accounts;

    const totalAccounts = accounts.length;

    const balanceIncludedAccounts = accounts.reduce(
      (accum: number, account: any) => accum + (account.includeInScenario ? Math.floor(account.balance) : 0),
      0,
    );

    const otherAccounts = accounts.reduce(
      (accum: number, account: any) => accum + (account.displayGroup === 'Outside Retirement Accounts' ? 1 : 0),
      0,
    );

    const getParticipantProfileBpID = riScenario.participantProfile?.bpId;
    const getSpouseProfileBpID = riScenario.spouseProfile?.bpId;
    const getParticipantProfileName = riScenario.participantProfile?.firstName + " " + riScenario.participantProfile?.lastName;
    const getSpouseProfileName = riScenario.spouseProfile?.firstName + " " + riScenario.spouseProfile?.lastName;

    const includedAccounts = accounts.reduce(
      (accum: number, account: any) => accum + (account.includeInScenario ? 1 : 0),
      0,
    );

    return (
      <React.Fragment>
        <ReactModalHeader
          modalTitle={`Strategy Balance (${accounts.length > 0
            ? (includedAccounts) + ' of ' + totalAccounts + ' Accounts'
            : (includedAccounts) + ' Account'
            } Included)`}
          showClose={true}
          handleCloseIconClick={this.handleCancel}
        />
        <ReactModalContent>
          <StrategyBalanceHeaderText id={'strategy-balance-header-text'}>
            If you exclude an account from this strategy, it will be excluded from your retirement savings balances and projections throughout the site.
          </StrategyBalanceHeaderText>
          <CurrentBalanceContainer id={'strategy-balance-container'}>
            <CurrentBalanceAmount id={'strategy-balance-amount'}>{formatAmountWithoutDecimals(balanceIncludedAccounts)}</CurrentBalanceAmount>
            <CurrentBalance id={'strategy-balance-amount-text'}>Balance (included in strategy)</CurrentBalance>
          </CurrentBalanceContainer>
          <CollapsibleHedge id={'strategy-balance-info-text'} title={'Information About As Of Dates'} bodyCopy={collapsibleText} />
          <AccountsContent>
            <TRPAccountsHeader id={'strategy-balance-workplace-accounts-header'}>Workplace Retirement Accounts</TRPAccountsHeader>
            <div>
              {accounts.map(
                (account: any, i: number) =>
                  account.displayGroup === 'T. Rowe Price Retirement Accounts' && (
                    <AccountCardRow>
                      <AccountCard
                        data={{ ...account }}
                        page="strategyBalance"
                        key={i}
                        id={'strategy-balance-workplace-account' + i}
                        participantName={account.bpId === getParticipantProfileBpID ? getParticipantProfileName : null}
                        spouseName={account.bpId === getSpouseProfileBpID ? getSpouseProfileName : null}
                      />
                      {!account.includeOnly ?
                        (
                          <ToggleSection
                            isOn={account.includeInScenario}
                            id={'strategy-balance-workplace-account-toggle' + i}
                            handleIncludeExclude={() => this.updateIncludeExcludeToggle(account.id, account.name)} />
                        )
                        :
                        (<AlwaysIncludeText id={'strategy-balance-workplace-account-always-include'}>Always<br /> Included</AlwaysIncludeText>)}

                    </AccountCardRow>
                  ),
              )}
            </div>
            {otherAccounts > 0 ? (
              <OtherAccountsHeader>Other Accounts</OtherAccountsHeader>
            ) : ''}
            <div>
              {accounts.map(
                (account: any, i: number) =>
                  account.displayGroup !== 'T. Rowe Price Retirement Accounts' && (
                    <AccountCardRow>
                      <AccountCard
                        data={{ ...account, displayType: this.getDisplayType(account), }}
                        page="strategyBalance"
                        key={i}
                        id={'strategy-balance-other-account' + i}
                        participantName={account.bpId === getParticipantProfileBpID ? getParticipantProfileName : null}
                        spouseName={account.bpId === getSpouseProfileBpID ? getSpouseProfileName : null}
                      />
                      <ToggleSection
                        isOn={account.includeInScenario}
                        id={'strategy-balance-other-account-toggle' + i}
                        handleIncludeExclude={() => this.updateIncludeExcludeToggle(account.id, account.name)}
                      />
                    </AccountCardRow>
                  ),
              )}
            </div>
          </AccountsContent>
          {/* <StrategyBalanceLinkContainer>
            <Button
              title="Seem off? Review and update your accounts."
              type="textButton"
              onClick={this.showYourAccountsModal}
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showYourAccountsModal)}
              id={'strategy-balance-update-accounts-link'}
            />
          </StrategyBalanceLinkContainer> */}
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Done"
          handleCTAClick={this.handleSave}
          CTAButtonId={analyticsTracking.RIXStrategyBalModalDone}
          CancelButtonId={analyticsTracking.RIXStrategyBalModalCancel}
          handleCancelClick={this.handleCancel}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  account: { currentPage, modelledScenario, tempScenario, accountHolderOptions },
  riScenario,
  charts,
  accountTypes,
}: any) => ({
  accounts: tempScenario.accounts,
  currentPage,
  modelledScenario,
  updatedAccounts: tempScenario.accounts?.filter((account: any) => account.action === 'UPDATE'),
  riScenario,
  accountTypes,
  isLoading: riScenario.loading || charts.loading,
  accountHolderOptions,
});

export default connect(mapStateToProps, {
  setCurrentView: accountActions.setCurrentView,
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  setSelectedAccount: accountActions.setSelectedAccount,
  updateAccountsData: accountActions.updateAccountsData,
  postSimulation: chartsActions.postSimulation,
  updateIncludeInScenario: strategyModalActions.updateIncludeInScenario,
  modelIncludeInScenario: strategyModalActions.modelIncludeInScenario,
  setInitialIncludeInScenario: strategyModalActions.setInitialIncludeInScenario,
})(StrategyModal);
